import {
  Component,
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  QueryList,
  Renderer2,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AdMessageService } from '@internal/common-ui/ad-message';

import { ResizeObserver } from 'resize-observer';

@Directive({
  selector: '[ellipsis]',
})
export class AdEllipsisDirective {
  @Input()
  rows: number = 1;
  _words: string;
  @Input('ellipsis')
  get words(): string {
    return this._words;
  }
  set words(val: string) {
    this._words = val;
    this.updateAnchorTitle();
  }

  @Input()
  tooltip: string;

  @Input()
  action: 'click' | 'hover' = 'click';

  @Input()
  tooltipTemplate: TemplateRef<any>;

  @Input()
  enable: boolean = true;

  @Input()
  mode: 'default' | 'expand' = 'default';

  @Input()
  hideText: string = 'Hide';

  @Input()
  showHide: boolean = true;

  @Input()
  styleClass: string;

  @Input()
  expandIcon: string = 'fas fa-chevron-down';

  @Input()
  collapseIcon: string = 'fas fa-chevron-up';

  // @Input()
  // useAnimation: boolean = true;

  hostElement: HTMLElement;
  anchorElement: HTMLSpanElement;
  lineHeight: number;
  containerHeight: number;
  isUsingContentText: boolean;

  tooltipEvent: () => void = null;

  originalHeight: string;
  orginalMaxHeight: string;
  originalOverflow: string;
  expanded: boolean = false;

  observer: ResizeObserver = new ResizeObserver((entries, observerSelf) => {
    this.updateAnchorVisible();
  })

  get isViewMore() {
    return this.mode === 'expand';
  }

  constructor(
    private elementRef: ElementRef<any>,
    private render: Renderer2,
    private viewContainer: ViewContainerRef,
    private adMessageService: AdMessageService
  ) {
    this.hostElement = elementRef.nativeElement;
  }

  createAnchorElement() {
    if (this.isViewMore) {
      this.anchorElement = document.createElement('div');
      this.anchorElement.className = `a-ellipsis-viewmore ${this.styleClass}`;
      const arrowIcon = document.createElement('span');
      this.anchorElement.appendChild(arrowIcon);
      arrowIcon.className = `a-ellipsis-icon  ${this.expandIcon}`;

      this.originalHeight = this.hostElement.style.height;
      this.orginalMaxHeight = this.hostElement.style.maxHeight;
      this.originalOverflow = this.hostElement.style.overflow;
      this.bindingEvent();
      this.hostElement.parentNode.insertBefore(this.anchorElement, this.hostElement.nextSibling);
    } else {
      this.anchorElement = document.createElement('span');
      this.anchorElement.className = `dsf-clickable a-ellipsis-anchor ${this.styleClass}`;
      if (this.tooltipTemplate != null) {
        this.bindingEvent();
      } else {
        // this.anchorElement.title = this.tooltip || this.hostElement.textContent;
        this.isUsingContentText = !(this.words?.length > 0);
        this.anchorElement.title = !this.isUsingContentText
          ? this.words
          : (this.tooltip || this.hostElement.textContent);
      }
      this.hostElement.style.position = 'relative';
      this.hostElement.appendChild(this.anchorElement);
    }

  }

  updateAnchorTitle() {
    if (this.anchorElement && this.tooltipTemplate == null) {
      this.anchorElement.title = this.words || this.hostElement.textContent;
      this.isUsingContentText =
        this.anchorElement.title === this.hostElement.textContent;
    }
  }

  bindingEvent() {
    if (this.isViewMore) {
      this.tooltipEvent = this.render.listen(
        this.anchorElement.firstElementChild,
        'click',
        () => {
          const arrowIcon = this.anchorElement.firstElementChild as HTMLSpanElement;
          if (this.expanded) {
            this.hostElement.style.height = this.originalHeight;
            this.hostElement.style.maxHeight = this.orginalMaxHeight;
            this.hostElement.style.overflow = 'hidden';
            arrowIcon.className = arrowIcon.className.replace(this.collapseIcon, this.expandIcon);
            arrowIcon.scrollIntoView({ block: 'end', behavior: 'smooth' });
            // if (this.useAnimation) {
            //   this.hostElement.animate(
            //     [{ transform: 'scaleY(1.1) translateY(10%)' },
            //     { transform: 'scaleY(1) translateY(0)' },],
            //     {
            //       duration: 300,
            //     }
            //   )
            // }
          } else {
            if (this.showHide) {
              arrowIcon.className = arrowIcon.className.replace(this.expandIcon, this.collapseIcon);
            }
            this.hostElement.style.height = 'auto';
            this.hostElement.style.maxHeight = 'unset';
            this.hostElement.style.overflow = 'visible';
            //arrowIcon.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            // if (this.useAnimation) {
            //   this.hostElement.animate(
            //     [{ transform: 'scaleY(0.9) translateY(-10%)' },
            //     { transform: 'scaleY(1) translateY(0)' },],
            //     {
            //       duration: 300,
            //     }
            //   )
            // }
          }
          this.expanded = !this.expanded;

        }
      )
    } else {
      this.tooltipEvent = this.render.listen(
        this.anchorElement,
        this.action,
        () => {
          this.adMessageService.openPanelTemplate(
            this.tooltipTemplate,
            this.viewContainer,
            { $implicit: this.tooltip || this.hostElement.textContent },
            this.elementRef,
            true
          );
        }
      );
    }

  }
  unbindingEvent() {
    this.tooltipEvent?.();
  }

  applyStyleToHost() {
    if (!this.isViewMore) {
      if (this.rows === 1) {
        this.hostElement.style.textOverflow = 'ellipsis';
        this.hostElement.style.whiteSpace = 'nowrap';
        this.hostElement.style.overflow = 'hidden';
      } else if (this.rows > 1) {
        this.hostElement.style.display = '-webkit-box';
        this.hostElement.style.webkitLineClamp = `${this.rows}`;
        this.hostElement.style.webkitBoxOrient = 'vertical';
        this.hostElement.style.overflow = 'hidden';
      }
      this.hostElement.style.maxWidth = this.hostElement.style.maxWidth || '80%';
    }
    else {
      this.hostElement.style.overflow = 'hidden';
    }
  }

  ngOnInit() {
    if (this.enable) {
      this.createAnchorElement();
      this.lineHeight = Math.floor(
        Number.parseFloat(window.getComputedStyle(this.hostElement).lineHeight)
      );
      this.applyStyleToHost();
      this.updateAnchorVisible();
    }
    this.observer.observe(this.hostElement);
  }

  ngAfterViewInit() {
    this.lineHeight = Math.floor(
      Number.parseFloat(window.getComputedStyle(this.hostElement).lineHeight)
    );
    this.containerHeight = Math.floor(
      Number.parseFloat(window.getComputedStyle(this.hostElement).height)
    );
    this.createAnchorElement();
    this.applyStyleToHost();
    this.updateAnchorVisible();
  }

  updateAnchorVisible() {
    if (this.anchorElement == null) return;
    const offsetHeight = this.hostElement.offsetHeight;
    const scrollHeight = this.hostElement.scrollHeight;
    const offsetWidth = this.hostElement.offsetWidth;
    const scrollWidth = this.hostElement.scrollWidth;
    if (
      scrollHeight - offsetHeight >= 8 ||
      (!this.isViewMore && this.rows === 1 && scrollWidth >= offsetWidth) ||
      this.expanded
    ) {
      this.anchorElement.style.display = this.isViewMore ? 'block' : 'unset';
    } else {
      this.anchorElement.style.display = 'none';
    }
  }

  ngOnDestroy() {
    this.unbindingEvent();
    this.observer.disconnect();
  }

  ngAfterViewChecked() {
    if (this.isUsingContentText) {
      const currentText = this.hostElement.textContent;
      if (currentText !== this.anchorElement.title) {
        this.anchorElement.title = currentText;
      }
    }
  }
}
